import React from 'react'

import "../styles/errors.scss";

export interface IErrorMessageProps {
	children: React.ReactNode
}

const ErrorMessage: React.FunctionComponent<IErrorMessageProps> = ({ children }) => {
	return (
		<div className="hwi-errormessage">
			<h1>Oops!</h1>
			{children}
		</div>
	)
}

export default ErrorMessage;